import {
  Alert,
  Card,
  Chip,
  LinearProgress,
  Stack,
  Button,
} from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React, { useEffect, useState } from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import AddSuggestion from './components/AddSuggestion';
import GetPostResponse from 'Global/Functions/GetPostResponse/GetPostResponse';
import { env } from 'env';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { Post } from 'Xhr/Xhr';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';

const SuggestionList = ({
  setUiValue,
  element,
  setForceRender,
  forceRender,
  onChange,
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    Post(
      'POST',
      `${process.env.REACT_APP_API_URL_API_GET_ELS_RECORD_DEFAULT_ANSWER}`,
      true,
      {
        id: element.ElsRecord.Id,
        GenderType: 0,
      }
    ).then((response) => {
      if (response.data.resCode === 1) {
        setData(response.data.Data);
      } else {
        SwalAlert('error', response.data.resMessage, false);
      }
    });
  }, [forceRender]);

  // const data = GetPostResponse(
  //   `${process.env.REACT_APP_API_URL_API_GET_ELS_RECORD_DEFAULT_ANSWER}`,
  //   true,
  //   {
  //     id: element.ElsRecord.Id,
  //     GenderType: 0,
  //   },
  //   forceRender
  // )?.Data;
  const label = FindLangKey(
    'general-public-default-suggestions'
  );
  const alertLabel = FindLangKey(
    'general-public-flat-alert-no-data'
  );
  const HandleSuggestionSelect = (suggestion) => {
    onChange(
      ArabicToPersian(
        suggestion?.FldName || suggestion?.AliasName
      )
    );
    setUiValue(
      ArabicToPersian(
        suggestion?.FldName || suggestion?.AliasName
      )
    );
  };

  return (
    <React.Fragment>
      <Card
        sx={{
          minWidth: '20em',
          minHeight: '10em',
          p: '1em',
        }}
      >
        <AddSuggestion
          FindLangKey={FindLangKey}
          element={element}
          setForceRender={setForceRender}
        />
        <p
          style={{
            textAlign: 'center',
            paddingBottom: '1em',
            fontSize: '.8em',
            marginTop: '.5em',
          }}
        >
          {label}
        </p>
        <Stack gap="1em">
          {data?.length > 0 ? (
            data?.map((suggestion) => (
              <Stack
                style={{ all: 'inherit' }}
                onClick={() => {
                  HandleSuggestionSelect(suggestion);
                }}
                key={suggestion?.FldId}
              >
                <Button
                  variant="contained"
                  sx={{
                    color: `${themeColors.ColorPrimary} !important`,
                  }}
                >
                  <Stack gap=".2em">
                    <p
                      style={{
                        fontWeight: 'bolder',
                        textAlign: 'center',
                      }}
                    >
                      {ArabicToPersian(
                        suggestion?.AliasName
                      )}
                    </p>
                    <p
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      {ArabicToPersian(
                        suggestion?.FldName ||
                          suggestion?.AliasName
                      )}
                    </p>
                  </Stack>
                </Button>
              </Stack>
            ))
          ) : data?.length === 0 ? (
            <Alert severity="warning">{alertLabel}</Alert>
          ) : (
            <LinearProgress />
          )}
        </Stack>
      </Card>
    </React.Fragment>
  );
};

export default SuggestionList;
